import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronGrabberHorizontal: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-grabber-horizontal"><path d="M9 16L5 12L9 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15 8L19 12L15 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChevronGrabberHorizontal;
